import React, { useEffect, useState } from "react";
import {
  MDBRow,
  MDBCol,
  MDBSelect,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBCard,
  MDBCardBody,
} from "mdb-react-ui-kit";
import Committees from "./Committees/Committees";
import Bills from "./Bills/Bills";
import Votes from "./Votes/Votes";
import About from "./About/About";

const LegislatorTabs = ({ legislator }) => {
  const [activeTab, setActiveTab] = useState("about");

  const handleTabClick = (tabId) => {
    if (activeTab !== tabId) {
      setActiveTab(tabId);
    }
  };

  return (
    <>
      <MDBRow>
        <MDBCol md="auto" className="order-2 order-md-1">
          <MDBTabs>
            <MDBTabsItem>
              <MDBTabsLink
                className="border border-bottom-0"
                onClick={() => handleTabClick("about")}
                active={activeTab === "about"}
              >
                About
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink
                className="border border-bottom-0"
                onClick={() => handleTabClick("committees")}
                active={activeTab === "committees"}
              >
                Committees
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink
                className="border border-bottom-0"
                onClick={() => handleTabClick("bills")}
                active={activeTab === "bills"}
              >
                Bills
              </MDBTabsLink>
            </MDBTabsItem>
            {/* <MDBTabsItem>
              <MDBTabsLink className="border border-bottom-0"
                onClick={() => handleTabClick("votesheets")}
                active={activeTab === "votesheets"}
              >
                Votes
              </MDBTabsLink>
            </MDBTabsItem> */}
          </MDBTabs>
        </MDBCol>
        <MDBCol md="auto" className="ms-auto order-1 order-md-2 mb-3 mb-md-0">
          <MDBSelect data={[{ text: "2025 (Regular Session)" }]} disabled />
        </MDBCol>
      </MDBRow>
      <MDBCard className="rounded-0 tab-card">
        <MDBCardBody className="p-4 tab-card-body">
          <MDBTabsContent>
            <MDBTabsPane open={activeTab === "about" ? true : false}>
              <About legislator={legislator} />
            </MDBTabsPane>
            <MDBTabsPane open={activeTab === "committees" ? true : false}>
              <Committees legislator={legislator} />
            </MDBTabsPane>
            <MDBTabsPane open={activeTab === "bills" ? true : false}>
              <Bills legislator={legislator} />
            </MDBTabsPane>
            {/* <MDBTabsPane open={activeTab === "votesheets" ? true : false}>
              <Votes legislator={legislator} />
            </MDBTabsPane> */}
          </MDBTabsContent>
        </MDBCardBody>
      </MDBCard>
    </>
  );
};

export default LegislatorTabs;
